import React from 'react'
import "./orbitPlanetDecoration.scss"
//Necesita que el padre tenga positicionamiento relativo.
//Recibe el tipo de órbita, limitado a la implementación del estilo del componente dentro de su hoja de estilo
const OrbitPlanetDecoration = ({type, rotationZ, color}) =>{
    return(
        <>
            <div style ={{transform: `translate(-50%, -50%) rotateZ(${rotationZ})`, borderColor: color?color:"none"}} className = {`orbit-planet__orbit orbit-planet__orbit--size-${type}`}>
                <div style = {{backgroundColor: color?color:"none"}} className = 'orbit-planet__planet'></div>
            </div>
        </>
    )
}

export default OrbitPlanetDecoration;